import { Group } from '@visx/group';

import { useTheme } from '@simplywallst/ui-core';

import { VisxText } from '@/components/VisxText';

import { formatterPercentage } from '@/utilities/format';

import { useSVGElementWidth } from '@/hooks/useSVGElementWidth';
import { LABEL_HEIGHT } from '../../constants';
import { Fill } from '../../types';
import { getPosition } from '../../utils';

interface Props {
  x: number;
  y: number;
  label: string;
  weight: number;
  fill: Fill;
}

export const Label = ({ x, y, label, weight, fill }: Props) => {
  const theme = useTheme();

  const [refA, widthA] = useSVGElementWidth();
  const [refB, widthB] = useSVGElementWidth();

  const padding = theme.x1;

  const width = Math.max(widthA, widthB) + padding;

  const position = getPosition(x);

  return (
    <Group left={x} top={y} data-cy-id={`label-${label}-${weight}`}>
      <rect
        transform={`translate(${position === 'left' ? 0 : -width} ${-(
          LABEL_HEIGHT / 2
        )})`}
        height={LABEL_HEIGHT}
        width={width}
        fill={theme.color.noir}
      />
      <VisxText
        dy={-theme.x0_5}
        innerRef={refA}
        typography="tiny"
        verticalAnchor="end"
        textAnchor={position === 'left' ? 'start' : 'end'}
        fill={fill}
      >
        {label}
      </VisxText>
      <VisxText
        dy={theme.x0_5}
        innerRef={refB}
        typography="tiny"
        verticalAnchor="start"
        textAnchor={position === 'left' ? 'start' : 'end'}
        fill={theme.color.white}
      >
        {formatterPercentage(weight)}
      </VisxText>
    </Group>
  );
};
